<template>
  <button
    v-if="auth.authenticated.value && auth.user.value?.id != comment.user?.id"
    @click="toggleVoteForComment()"
    class="flex gap-0.5 items-center"
  >
    <IconArrowUp :bold="hasVoted" />
    <span>{{ numberOfVotes }}</span>
  </button>
  <div v-else class="flex gap-0.5 items-center">
      <IconArrowUp />
    <span>{{ numberOfVotes }}</span>
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{ comment: Comment, voted?: Boolean }>();

const auth = useAuth();
const hasVoted = ref(props.voted);

watch(
  () => props.voted,
  (value) => {
    hasVoted.value = value;
  }
);

const numberOfVotes = ref(
  props.comment.numberOfVotes ? props.comment.numberOfVotes : 0
);

function toggleVoteForComment() {
  let endpoint = 'vote';

  if (props.voted) {
    endpoint = 'unvote';
  }

  useApiAuth()
    .post<Comment>("comments/" + props.comment.id.toString() + "/" + endpoint)
    .then(function (response) {
      hasVoted.value = !hasVoted.value;
      if (hasVoted.value) {
        numberOfVotes.value++;
      } else {
        numberOfVotes.value--;
      }
    });
}
</script>
